import { useEffect, useState } from 'react'
import { Select } from 'antd'
import { API } from 'src/utils/interceptor'
import {
  reportGroupLeftOutSentence,
  reportGroupOptionLabel,
  reportGroupPickNote,
  venueIdsForReportGroup,
} from './reportGroupVenues'
import {
  shouldAskVenueReportCsvGroup,
  VENUE_REPORT_CSV_GROUP_ASK,
  VENUE_REPORT_CSV_GROUP_PLACEHOLDER,
} from './venueReportCsv'

/**
 * Picks a venue group and ticks the venues this report can use.
 * Clearing the group does not clear those ticks.
 */
const ReportGroupSelect = ({
  venues,
  onPick,
  chooseOne = false,
  formatNote,
  overrideNote,
  onAsking,
}) => {
  const [groups, setGroups] = useState([])
  const [groupId, setGroupId] = useState('')
  const [note, setNote] = useState('')
  const [offerIds, setOfferIds] = useState([])

  useEffect(() => {
    if (onAsking) onAsking(offerIds.length > 0)
  }, [offerIds, onAsking])

  useEffect(() => {
    let cancelled = false
    API.get('api2', 'venue-groups')
      .then(response => {
        if (!cancelled) setGroups(response?.data || [])
        return null
      })
      .catch(() => {
        if (!cancelled) setGroups([])
        return null
      })
    return () => {
      cancelled = true
    }
  }, [])

  const choose = id => {
    const nextId = id || ''
    setGroupId(nextId)
    if (!nextId) {
      setNote('')
      setOfferIds([])
      return
    }
    const group = groups.find(row => String(row._id) === String(nextId))
    const picked = venueIdsForReportGroup(group, venues)
    if (chooseOne && shouldAskVenueReportCsvGroup(picked.venueIds)) {
      setOfferIds(picked.venueIds)
      const leftOut = reportGroupLeftOutSentence(picked)
      setNote(
        leftOut
          ? `${VENUE_REPORT_CSV_GROUP_ASK} ${leftOut}`
          : VENUE_REPORT_CSV_GROUP_ASK,
      )
      onPick([])
      return
    }
    setOfferIds([])
    if (overrideNote === undefined) {
      const pickedNote = formatNote
        ? formatNote(picked)
        : chooseOne
        ? reportGroupLeftOutSentence(picked)
        : reportGroupPickNote(picked)
      setNote(pickedNote)
    }
    onPick(picked.venueIds)
  }

  const chooseOfferedVenue = id => {
    setOfferIds([])
    setNote('')
    if (id) onPick([id])
  }

  const offeredVenues = offerIds
    .map(id => (venues || []).find(venue => String(venue?._id) === String(id)))
    .filter(Boolean)
    .sort((a, b) => String(a.title || '').localeCompare(String(b.title || '')))

  return (
    <>
      <Select
        showSearch
        allowClear
        placeholder='Use a group'
        optionFilterProp='children'
        value={groupId || undefined}
        onChange={choose}
        style={{ marginBottom: 15, width: 355 }}
      >
        {groups.map(group => (
          <Select.Option key={group._id} value={group._id}>
            {reportGroupOptionLabel(group)}
          </Select.Option>
        ))}
      </Select>
      {(overrideNote != null ? overrideNote : note) ? (
        <p>{overrideNote != null ? overrideNote : note}</p>
      ) : null}
      {offeredVenues.length > 0 ? (
        <Select
          showSearch
          placeholder={VENUE_REPORT_CSV_GROUP_PLACEHOLDER}
          optionFilterProp='children'
          onChange={chooseOfferedVenue}
          style={{ marginBottom: 15, width: 355 }}
        >
          {offeredVenues.map(venue => (
            <Select.Option key={venue._id} value={venue._id}>
              {venue.title}
            </Select.Option>
          ))}
        </Select>
      ) : null}
    </>
  )
}

export default ReportGroupSelect
